export const DEFAULT = 'default';
export const CUSTOM = 'custom';